import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withNotification } from 'wrappers';
import { Container, Grid, Hidden } from '@material-ui/core';
import {
    Loader, PdfViewerBase, BaseModal, BaseModalError, ButtonBase, HeaderBase,
} from 'components';
import {
    abreviaturas, messages, masterMessages, masterEvents,
} from 'constantes';
import endPoints from 'endPoints/endPoints';
import { makeStyles } from '@material-ui/core/styles';
import Cookie from 'js-cookie';
import {
    base64ToBlob, blobToBase64, validatePermissionDoc,
} from 'utils/Functions';
import { downloadPdf } from 'utils/pdfUtils';
import { ReactComponent as DocCompleted } from 'assets/images/docCompleted.svg';
import { PdfViewerBusiness } from 'business/business/PdfViewerBusiness';
import { AnalyticsAmplitud } from 'utils/Analytics-Amplitud';
import authService from 'auth/AuthService';
import ModalCancelDoc from './ModalCancelDoc';

// Estilos de la pagina
const useStyles = makeStyles(() => ({
    imgContainerModalDownload: {
        textAlign: 'center',
        width: '50%',
        height: '40%',
    },
    imgModal: {
        width: '70%',
        height: 'auto',
        marginBottom: 2,
    },
    imgModalProceso: {
        width: '90%',
        height: 'auto',
        marginBottom: 2,
    },
    buttonDownload: {
        position: 'fixed',
        bottom: 15,
        left: '90%',
        height: '12%',
        width: '6%',
    },
    spamDetalle: {
        color: '#C00333',
        marginRight: '55%',
    },
    detalleMessage: {
        marginRight: '80%',
    },
}));

function PdfViewer(
    {
        appSuccess, appError, history, match,
    },
) {
    const { params: { solicitudId } } = match;
    const classes = useStyles();
    // Mensajes mostrar
    const {
        pdfViewer: {
            modalDocFirm, modalDocError, modalDocProceso, modalDocSuccessMessages,
        },
        buttons,
    } = masterMessages;
    // Se extrae la ruta
    const { pdfViewer } = endPoints || {};
    const [loading, setLoading] = useState(true);
    const [solicitudPDF, setSolicitudPDF] = useState(null);
    const [statusPDFDownload, setStatusPDFDownload] = useState(false);
    const [statusPDFError, setStatusPDFError] = useState({});
    const [modalCancel, setModalCancel] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modalErrorProceso, setModalErrorProceso] = useState(false);
    const [modalDocSuccess, setModalDocSuccess] = useState(false);
    const [modalDownloadConfirm, setModalDownloadConfirm] = useState(false);
    const [signedPdfBlobLocal, setSignedPdfBlobLocal] = useState(null);

    // Eeventos para Modales
    const handleCloseModal = () => {
        setStatusPDFDownload(false);
        setModalCancel(false);
        setModalError(false);
        setModalErrorProceso(false);
        setModalDocSuccess(false);
        setModalDownloadConfirm(false);
    };

    const handleOpenModalCancel = () => setModalCancel(true);

    /**
     * @name getDocFirmaBinary
     * @desc Consulta el documento al api y devuelve un binario
     * @returns {Promise<*|null>}
     */
    const getDocFirmaBinary = async () => {
        const res = await PdfViewerBusiness.getDocumentReader(solicitudId);
        if (res.status !== abreviaturas.DEFAULT_HTTP_FAIL[0]) {
            const dataText = await res.text();
            const blobPdf = await base64ToBlob(dataText); // Se convierte respuesta en blob

            return blobPdf || null;
        }
            setLoading(false);
            setModalErrorProceso(true);
            return null;
    };

    /**
     * @name getDocFirma
     * @desc Función que realiza consulta al api para cargar el documento a mostrar
     * @returns {Promise<void>}
     */
    const getDocFirma = async () => {
        try {
            // Se envia solicitud al api del id de la solicitud
            const blobPdf = await getDocFirmaBinary();
            setSolicitudPDF(blobPdf);
            // Conexión con analiticas al cargar el documento
            AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_CARGA_PDF);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            appError(messages.dataFetch.fail);
        }
    };

    /**
     * @name getDocFirmaStatus
     * @desc Ejecuta funcion para consultar documento y cargar variable con el
     * @returns {Promise<void>}
     */
    const getDocFirmaStatus = async () => {
        setModalErrorProceso(false);
        try {
            // Se envia solicitud al api del id de la solicitud
            const resEstatus = await PdfViewerBusiness.getDocumentReaderStatus(solicitudId);
            const dataJson = resEstatus.json();
            dataJson.then((resp) => {
                if (resp.estado === abreviaturas.STATUS_COMPLETADA) {
                    setStatusPDFDownload(resp.estado === abreviaturas.STATUS_COMPLETADA);
                } else if (resp.estado === abreviaturas.STATUS_ERROR) {
                    setStatusPDFError(resp);
                    setModalError(resp.estado === abreviaturas.STATUS_ERROR);
                } else if (resp.estado === abreviaturas.STATUS_ENPROCESO) {
                    setModalErrorProceso(resp.estado === abreviaturas.STATUS_ENPROCESO);
                } else if (resp.estado === abreviaturas.STATUS_CREADA) {
                    getDocFirma().then((res) => res);
                }
                setLoading(false);
            });
        } catch (e) {
            appError(messages.dataFetch.fail);
        }
    };

    // Se inicializa el componete
    useEffect(() => {
        // Detectar si hay múltiples IDs separados por comas
        if (solicitudId && solicitudId.includes(',')) {
            // Redirigir al visor batch con los múltiples IDs
            history.replace(`/apiv1/batch-pdf-viewer?ids=${solicitudId}`);
            return;
        }

        // Conexión con analiticas al cargar la vista
        AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_VISTA_PDF);

        // Consulto permisos sobre el doc
        const fetchPermissionsDoc = async () => {
            await validatePermissionDoc(solicitudId).then((res) => {
                setModalErrorProceso(res);
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
                setModalErrorProceso(e);
            });
        };

        fetchPermissionsDoc().then((res) => res);

        if (!modalErrorProceso) {
            // Consultamos estado del doc
            const statusDoc = async () => {
                await getDocFirmaStatus();
            };

            statusDoc().then((res) => res);
        } else {
            setLoading(false);
        }
    }, []);

    /**
     * @name mapValues
     * @desc Compone objeto de datos a enviar al api en parametros de función
     * @param signatureFileB64
     * @param geoData
     * @returns {Promise<{base64Document: *, campos: [
     * {nombreCampo: string, valorCampo: (*|string)},{nombreCampo: string, valorCampo: (*|string)},
     * {nombreCampo: string, valorCampo: string},{nombreCampo: string, valorCampo: string},
     * {nombreCampo: string, valorCampo: (*|string)},null,null]}>}
     */
    const mapValues = async (signatureFileB64, selfieData) => {
        // Parametros de coordenadas e ip
        const lat = null;
        const long = null;
        let ip = null;
        let loc = null;

        try {
          // Obtener la información de Ipify
          await fetch(pdfViewer.geoAltern)
              .then((response) => {
                  if (!response.ok) {
                      throw new Error('Error de CORS Ipify');
                  }
                  return response.text();
              })
              .then((result) => {
                const { ip: dirIp } = JSON.parse(result) || {};
                ip = dirIp || '0.0.0.0';
                loc = '';
              });
      } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error al obtener la información de geolocalización:', error.message);
      }

        // Datos de la sesion actual
        const infoSession = await authService.getSessionInfo();
        const { t: token } = infoSession || {};
        const nombre = Cookie.get(abreviaturas.SIDUSUARIO);

        // Captura de codigo OTP
        const otpNumber = Cookie.get(abreviaturas.DEFAULT_OTP_NUMBER);

        // Extraer base64 puro de la selfie
        let selfieB64 = '';
        if (selfieData) {
            const parts = selfieData.split(',');
            selfieB64 = parts[1] || '';
        }
        const dataFile = {
            base64Document: signatureFileB64,
            campos: [
                {
                    nombreCampo: 'Dirección IP',
                    valorCampo: ip || '0.0.0.0',
                },
                {
                    nombreCampo: 'Locación (Pais)',
                    valorCampo: loc || '',
                },
                {
                    nombreCampo: 'Latitud',
                    valorCampo: lat || '',
                },
                {
                    nombreCampo: 'Longitud',
                    valorCampo: long || '',
                },
                {
                    nombreCampo: 'Token',
                    valorCampo: token || '',
                },
                {
                    nombreCampo: 'Nombre usuario',
                    valorCampo: nombre || '',
                },
                {
                    nombreCampo: 'Código OTP',
                    valorCampo: otpNumber || '',
                },
                {
                    nombreCampo: 'Foto Selfie',
                    valorCampo: selfieB64,
                },
            ],
        };

        return dataFile;
    };

    /**
     * @name onSavePdf
     * @desc Trae el documento PDF y lo envia al api en B64
     * @param signatureFileB64
     * @returns {Promise<void>}
     */
    const onSavePdf = async (pdfBlob, selfieData) => {
        setLoading(true);
        try {
            // Se convierte a B64
            const dataB64 = await blobToBase64(pdfBlob);
            const fileB64 = dataB64.split(
                abreviaturas.DEFAULT_TYPE_CONTENT_B64,
            );

            // Se construye objeto
            const data = await mapValues(
                fileB64[1], selfieData,
            );

            // Solicitud al api
            const res = await PdfViewerBusiness.sendDocumentReader(data, solicitudId);

            if (res.status === abreviaturas.DEFAULT_HTTP_OK[0]
                || res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
                // Conexión con analiticas al tener exito de guardado
                AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_GUARDAR_FIRMA);
                setSignedPdfBlobLocal(pdfBlob);
                setLoading(false);
                appSuccess(messages.dataFetch.success);
                setModalDownloadConfirm(true);
            } else {
                appError(messages.errors.submitting);
            }
            setLoading(false);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error onSavePdf:', e);
            // Conexión con analiticas al tener un error
            AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_ERROR_FIRMA);
            setLoading(false);
            appError(messages.errors.submitting);
        }
    };

    /**
     * @name onDownloadPdf
     * @desc descarga un documento que ya fue firmado
     * @returns {Promise<void>}
     */
    const onDownloadPdf = async () => {
        setLoading(true);
        try {
            // Consultamos el documento
            const blobPdf = await getDocFirmaBinary();
            const url = URL.createObjectURL(blobPdf);
            window.open(url);
            // Conexión con analiticas al descargar un documento
            AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_DESCARGA_DOC);
            appSuccess(messages.dataFetch.success);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            appError(messages.dataFetch.fail);
        }
    };

    /**
     * @name onClickModalExit
     * @desc Lleva nuevamente a pagina de logueo tras mostrar error
     */
    const onClickModalExit = async () => {
        authService.logout();
        // Conexión con analiticas al salir del aplicativo
        AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_TERMINAT_SESION);
        history.push('/apiv1/sign-in');
    };

    // Descargar PDF firmado localmente y mostrar modal de firmado
    const handleConfirmDownload = () => {
        if (signedPdfBlobLocal) {
            downloadPdf(signedPdfBlobLocal, 'documento_firmado');
        }
        setModalDownloadConfirm(false);
        setModalDocSuccess(true);
    };

    // Omitir descarga y mostrar modal de firmado
    const handleSkipDownload = () => {
        setModalDownloadConfirm(false);
        setModalDocSuccess(true);
    };

    return loading ? <Loader /> : (
      <>
        {Boolean(!statusPDFDownload && solicitudPDF) && (
        <>
          <HeaderBase openModalCancel={handleOpenModalCancel} />
          <PdfViewerBase onHandleClick={onSavePdf} pdfFile={solicitudPDF} />
        </>
          )}

        {/* Modal de Error */}
        {Boolean(modalErrorProceso) && (
          <BaseModalError
            handleCloseModal={handleCloseModal}
            messages={modalDocProceso}
            maxWidth="sm"
          />
          )}

        {/* Modal para Cancelar un documento */}
        {Boolean(modalCancel) && (
          <ModalCancelDoc
            solicitudId={solicitudId}
            handleCloseModal={handleCloseModal}
            setLoading={setLoading}
            onClickModalExit={onClickModalExit}
          />
          )}

        {/* Modal para descargar documento firmado */}
        {Boolean(statusPDFDownload) && (
          <BaseModal
            open
            onClose={handleCloseModal}
            title={modalDocFirm.title}
            maxWidth="sm"
            close={false}
          >
            <Grid container>
              <Hidden only={['xs', 'md']}>
                <Grid item sm={12} md={12} xl={12}>
                  <Container className={classes.imgContainerModalDownload}>
                    <DocCompleted className={classes.imgModal} />
                  </Container>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={12}>
                <p>{modalDocFirm.message}</p>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption={buttons.downloadDoc}
                    colorBase={abreviaturas.DEFAULT_WHITE_COLOR}
                    onClickEvent={onDownloadPdf}
                  />
                </Grid>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption={buttons.exit}
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                    onClickEvent={onClickModalExit}
                  />
                </Grid>
              </Grid>
            </Grid>
          </BaseModal>
          )}

        {/* Modal de confirmacion de descarga */}
        {Boolean(modalDownloadConfirm) && (
          <BaseModal
            open
            onClose={handleSkipDownload}
            title="Documento guardado"
            maxWidth="sm"
            close={false}
          >
            <Grid container>
              <Hidden only={['xs', 'md']}>
                <Grid item sm={12} md={12} xl={12}>
                  <Container className={classes.imgContainerModalDownload}>
                    <DocCompleted className={classes.imgModal} />
                  </Container>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={12}>
                <p>
                  El documento ha sido guardado exitosamente.
                  ¿Desea descargar el PDF firmado?
                </p>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption="Sí, descargar"
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                    onClickEvent={handleConfirmDownload}
                  />
                </Grid>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption="No"
                    colorBase={abreviaturas.DEFAULT_WHITE_COLOR}
                    onClickEvent={handleSkipDownload}
                  />
                </Grid>
              </Grid>
            </Grid>
          </BaseModal>
          )}

        {/* Modal de exito en documento firmado */}
        {Boolean(modalDocSuccess && !modalError) && (
          <BaseModal
            open
            onClose={handleCloseModal}
            title={modalDocSuccessMessages.title}
            maxWidth="sm"
            close={false}
          >
            <Grid container>
              <Hidden only={['xs', 'md']}>
                <Grid item sm={12} md={12} xl={12}>
                  <Container className={classes.imgContainerModalDownload}>
                    <DocCompleted className={classes.imgModal} />
                  </Container>
                </Grid>
              </Hidden>
              <Grid item xs={12} md={12}>
                <p>{modalDocSuccessMessages.message}</p>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption={buttons.exit}
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                    onClickEvent={onClickModalExit}
                  />
                </Grid>
              </Grid>
            </Grid>
          </BaseModal>
          )}

        {/* Modal de documento cancelado */}
        {Boolean(modalError) && (
          <BaseModal
            open
            onClose={handleCloseModal}
            title={modalDocError.title}
            message={modalDocError.message}
            maxWidth="sm"
            close={false}
          >
            <Grid container>
              <Grid item xs={12} md={12}>
                <spam className={classes.spamDetalle}>Detalle:</spam>
                <p>{statusPDFError.mensajeError}</p>
              </Grid>
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption={buttons.exit}
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                    onClickEvent={onClickModalExit}
                  />
                </Grid>
              </Grid>
            </Grid>
          </BaseModal>
          )}
      </>
    );
}

PdfViewer.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            solicitudId: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
        }).isRequired,
    }).isRequired,
    appSuccess: PropTypes.func.isRequired,
    appError: PropTypes.func.isRequired,
};

export default withNotification(PdfViewer);
